// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SidebarPinnedHelp.css — client item #21.
 * Help & Resources sits at the bottom of the left menu, with a gap after the
 * main navigation. Imported by Sidebar.js AFTER Sidebar.css, so these rules win
 * over Sidebar.css on equal specificity.
 *
 * Layout: the sidebar becomes a flex column —
 *     header · divider · main nav (grows, scrolls if long) · pinned Help block
 * The Help block is a second \`.sb-nav\`, so items keep exactly the same
 * padding / hover / active styling as the main navigation.
 */

/* full sidebar */
.sb-sidebar {
  display: flex;
  flex-direction: column;
}
.sb-sidebar > .sb-header,
.sb-sidebar > .sb-divider {
  flex-shrink: 0;
}
.sb-sidebar > .sb-nav:not(.sb-bottom) {
  flex: 1 1 auto;
  min-height: 0;          /* lets the list scroll instead of pushing Help off-screen */
  overflow-y: auto;
}
.sb-sidebar > .sb-bottom {
  flex: 0 0 auto;
  margin-top: auto;
  padding-top: 10px;
  padding-bottom: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.10);
  max-height: 55%;        /* an expanded Help menu can't crowd out the main items */
  overflow-y: auto;
}

/* collapsed rail */
.sb-rail {
  display: flex;
  flex-direction: column;
}
.sb-rail > .sb-rail-nav {
  flex: 1 1 auto;
  min-height: 0;
}
.sb-rail-bottom {
  flex: 0 0 auto;
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.10);
}

/* ─────────────────────────────────────────────────────────────
 * Support ▸ User Guide ▸ section list — alignment fix
 *
 * Problem: the nested menus stacked ~96px of indent (nav padding + sub-menu
 * margin/padding + guide-menu margin/padding + link padding) inside a 242px
 * sidebar, and the links were \`white-space: nowrap\`, so labels were cut off
 * ("Data & Model Inp…") and the pinned block grew a scrollbar.
 *
 * Fix: smaller, even indents; long labels WRAP instead of being clipped;
 * no horizontal clipping/scrollbar; tighter row height so the whole list fits
 * without a vertical scrollbar. Selectors are prefixed with \`.sb-sidebar\` so
 * they win over Sidebar.css without !important.
 * ───────────────────────────────────────────────────────────── */

/* the pinned block never scrolls sideways; a vertical scroll (very short
   windows only) is allowed but its scrollbar is hidden like the sidebar's */
.sb-sidebar > .sb-bottom {
  overflow-x: hidden;
  max-height: 70%;
  scrollbar-width: none;
}
.sb-sidebar > .sb-bottom::-webkit-scrollbar { display: none; }

/* level 1 — Help items (User Guide, Examples …) */
.sb-sidebar .sb-help-menu {
  margin: 2px 4px 6px 16px;
  padding-left: 6px;
}
.sb-sidebar .sb-help-menu .sb-sub-link {
  padding: 6px 10px;
  font-size: 16px;
  min-width: 0;
  white-space: normal;          /* wrap instead of clipping */
  overflow-wrap: anywhere;
}

/* level 2 — the User Guide sections */
.sb-sidebar .sb-guide-menu {
  margin: 2px 0 6px 10px;
  padding-left: 6px;
}
.sb-sidebar .sb-guide-menu .sb-sub-link {
  padding: 4px 8px;
  font-size: 14px;
  line-height: 1.25;
  gap: 7px;
  align-items: flex-start;      /* dot / icon stays on the first line when a label wraps */
  white-space: normal;
  min-width: 0;
  overflow-wrap: anywhere;
}
.sb-sidebar .sb-guide-menu .sb-sub-icon {
  margin-top: 3px;              /* centre the icon on the first text line */
}
.sb-sidebar .sb-guide-menu .sb-sub-dot {
  margin-top: 6px;              /* active dot sits beside the first line too */
}`, "",{"version":3,"sources":["webpack://./src/styles/SidebarPinnedHelp.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;;AAEF,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa,WAAW,4DAA4D;EACpF,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,+CAA+C;EAC/C,eAAe,SAAS,yDAAyD;EACjF,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,+CAA+C;AACjD;;AAEA;;;;;;;;;;;;kEAYkE;;AAElE;4EAC4E;AAC5E;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA,8CAA8C,aAAa,EAAE;;AAE7D,kDAAkD;AAClD;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,mBAAmB,WAAW,6BAA6B;EAC3D,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,uBAAuB,OAAO,0DAA0D;EACxF,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,eAAe,eAAe,2CAA2C;AAC3E;AACA;EACE,eAAe,eAAe,8CAA8C;AAC9E","sourcesContent":["/* SidebarPinnedHelp.css — client item #21.\n * Help & Resources sits at the bottom of the left menu, with a gap after the\n * main navigation. Imported by Sidebar.js AFTER Sidebar.css, so these rules win\n * over Sidebar.css on equal specificity.\n *\n * Layout: the sidebar becomes a flex column —\n *     header · divider · main nav (grows, scrolls if long) · pinned Help block\n * The Help block is a second `.sb-nav`, so items keep exactly the same\n * padding / hover / active styling as the main navigation.\n */\n\n/* full sidebar */\n.sb-sidebar {\n  display: flex;\n  flex-direction: column;\n}\n.sb-sidebar > .sb-header,\n.sb-sidebar > .sb-divider {\n  flex-shrink: 0;\n}\n.sb-sidebar > .sb-nav:not(.sb-bottom) {\n  flex: 1 1 auto;\n  min-height: 0;          /* lets the list scroll instead of pushing Help off-screen */\n  overflow-y: auto;\n}\n.sb-sidebar > .sb-bottom {\n  flex: 0 0 auto;\n  margin-top: auto;\n  padding-top: 10px;\n  padding-bottom: 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.10);\n  max-height: 55%;        /* an expanded Help menu can't crowd out the main items */\n  overflow-y: auto;\n}\n\n/* collapsed rail */\n.sb-rail {\n  display: flex;\n  flex-direction: column;\n}\n.sb-rail > .sb-rail-nav {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n.sb-rail-bottom {\n  flex: 0 0 auto;\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.10);\n}\n\n/* ─────────────────────────────────────────────────────────────\n * Support ▸ User Guide ▸ section list — alignment fix\n *\n * Problem: the nested menus stacked ~96px of indent (nav padding + sub-menu\n * margin/padding + guide-menu margin/padding + link padding) inside a 242px\n * sidebar, and the links were `white-space: nowrap`, so labels were cut off\n * (\"Data & Model Inp…\") and the pinned block grew a scrollbar.\n *\n * Fix: smaller, even indents; long labels WRAP instead of being clipped;\n * no horizontal clipping/scrollbar; tighter row height so the whole list fits\n * without a vertical scrollbar. Selectors are prefixed with `.sb-sidebar` so\n * they win over Sidebar.css without !important.\n * ───────────────────────────────────────────────────────────── */\n\n/* the pinned block never scrolls sideways; a vertical scroll (very short\n   windows only) is allowed but its scrollbar is hidden like the sidebar's */\n.sb-sidebar > .sb-bottom {\n  overflow-x: hidden;\n  max-height: 70%;\n  scrollbar-width: none;\n}\n.sb-sidebar > .sb-bottom::-webkit-scrollbar { display: none; }\n\n/* level 1 — Help items (User Guide, Examples …) */\n.sb-sidebar .sb-help-menu {\n  margin: 2px 4px 6px 16px;\n  padding-left: 6px;\n}\n.sb-sidebar .sb-help-menu .sb-sub-link {\n  padding: 6px 10px;\n  font-size: 16px;\n  min-width: 0;\n  white-space: normal;          /* wrap instead of clipping */\n  overflow-wrap: anywhere;\n}\n\n/* level 2 — the User Guide sections */\n.sb-sidebar .sb-guide-menu {\n  margin: 2px 0 6px 10px;\n  padding-left: 6px;\n}\n.sb-sidebar .sb-guide-menu .sb-sub-link {\n  padding: 4px 8px;\n  font-size: 14px;\n  line-height: 1.25;\n  gap: 7px;\n  align-items: flex-start;      /* dot / icon stays on the first line when a label wraps */\n  white-space: normal;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.sb-sidebar .sb-guide-menu .sb-sub-icon {\n  margin-top: 3px;              /* centre the icon on the first text line */\n}\n.sb-sidebar .sb-guide-menu .sb-sub-dot {\n  margin-top: 6px;              /* active dot sits beside the first line too */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
